import * as React from "react";
import { SVGProps } from "react";
function SvgMeetingRecIconModal(props: SVGProps<SVGSVGElement>): JSX.Element {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M8 5v14l11-7L8 5Z" fill="#000" />
    </svg>
  );
}
export default SvgMeetingRecIconModal;
